import React from 'react';
import { Button } from 'reactstrap';
import { useNavigationActions } from '../../../../context';

/**
 * Component that displays the final cancellation success confirmation
 * Shows after successful cancellation with community access information
 */
const ErrorConfirmation = () => {
  // Get navigation actions from context
  const { returnToWLC } = useNavigationActions();

  return (
    <div className="cancellation-success-content">
      <div className="mb-4">
        <h5 className="mb-4">An error occurred.</h5>

        <p className="mb-3">
          We're sorry an error occurred while processing your request. Please try again later or contact us at
          support@foodrevolution.org
        </p>

        <div className="mb-4 text-center">
          <Button color="primary" onClick={returnToWLC} size="lg">
            Visit WHOLE Life Club Community Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorConfirmation;
